export class FeaturitProperties {
  environment: string;
  school_id: string;
  school_name: string;
  username: string;
  user_email: string;
  user_role: string[];
  distinct_id: string;
  course?: string;
  language: string;
  school_year: string;
  program: string;
  group: string;
  is_demo: boolean;
}

export class FeaturitParams {
  ui_label?: string;
  ui_path?: string;
  ui_object?: string;
  version?: string;
  eventKey?: string;
}
